import apiBase from './constants/api.base';
import color from './constants/color';
import defaultHeader from './constants/default.header';
import emptyFunction from './constants/empty.function';
import endpoint from './constants/endpoint';
import icon from './constants/icon';
import method from './constants/method';
import part from './constants/part';
import secretQuestions from './constants/secret.questions';
import siteLogoUrl from './constants/site.logo.url';
import siteUrl from './constants/site.url';
import width100Percent from './constants/width.100.percent';

export default {
    apiBase,
    color,
    defaultHeader,
    doNotSuppressError: false,
    emptyFunction,
    endpoint,
    icon,
    isInAVerticalList: true,
    method,
    part,
    secretQuestions,
    siteLogoUrl,
    siteUrl,
    minimumMediumViewportWidth: 768,
    suppressError: true,
    width100Percent,
};